import { toTitleCase } from 'utils/shared/toTitleCase';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import { PromptUserProps } from 'screens/PlayerLoggedInScreen/props';
import Button from 'components/Button';

const PromptUser: React.FC<PromptUserProps> = ({ coach, handleClose, onNext }) => {
  return (
    <div className="flex flex-col pt-ds-xl">
      <div className="flex flex-col items-center justify-center px-ds-xl text-center">
        <img
          alt="profile-avatar"
          src={getProfileImageUrlOrPlaceholder({ path: coach?.profileImagePath || '' })}
          className="h-32 w-32 rounded-full object-cover object-top"
        />

        <h2 className="typography-product-heading-desktop mt-8">
          Book a lesson with coach {toTitleCase(coach?.fullName || '')}
        </h2>
        <p className="typography-product-body mt-2 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          Quickly schedule a lesson for seamless progress.
        </p>
      </div>
      <div className="mt-12 flex gap-4 border-t border-color-border-input-lightmode px-ds-xl  py-4 dark:border-color-border-input-darkmode">
        <Button variant="secondary" size="lg" onClick={handleClose}>
          No
        </Button>
        <Button variant="primary" size="lg" onClick={onNext}>
          Yes
        </Button>
      </div>
    </div>
  );
};

export default PromptUser;
